import { gql, useMutation } from "@apollo/client";

const CREATE_MOOD_BOARD = gql`
  mutation CreateNewDesignBoard(
    $name: String
    $type: DesignBoardType
    $description: String
    $why: String
    $designerId: ID
    $color: [ColorFamily]
    $texture: [Textures]
    $finish: [Finishes]
    $pattern: [Patterns]
    $roomType: [ProjectCategory]
    $greatFor: GreatFor
    $images: [ID]
    $published: Boolean
  ) {
    createNewDesignBoard(
      name: $name
      type: $type
      description: $description
      why: $why
      designerId: $designerId
      color: $color
      texture: $texture
      finish: $finish
      pattern: $pattern
      roomType: $roomType
      greatFor: $greatFor
      images: $images
      published: $published
    ) {
      _id
      name
      type
      description
      why
      designerId
      color
      texture
      finish
      pattern
      roomType
      greatFor
      images
      published
    }
  }
`;

export const useCreateMoodBoardMutation = () => {
  const [createMoodBoardMutation, { loading, error, data }] =
    useMutation(CREATE_MOOD_BOARD);

  const createMoodBoard = async (args: any) => {
    try {
      const { data } = await createMoodBoardMutation({
        variables: args,
      });
      return data?.createNewDesignBoard;
    } catch (error) {
      console.error("Error creating mood board:", error);
      throw error;
    }
  };
  return { createMoodBoard, loading, error, data };
};
